import { render, staticRenderFns } from "./PropertyMeasureCard.vue?vue&type=template&id=93db656a&scoped=true"
import script from "./PropertyMeasureCard.vue?vue&type=script&lang=js"
export * from "./PropertyMeasureCard.vue?vue&type=script&lang=js"
import style0 from "./PropertyMeasureCard.vue?vue&type=style&index=0&id=93db656a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93db656a",
  null
  
)

export default component.exports